import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["url", "modifier", "autoplay", "isCaptionDisplayed", "caption", "credits", "areVideoCreditsDisplayed", "provider", "playInModal", "imageId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import PropTypes from 'prop-types';
import useGetImages from '../../hooks/use-get-images';
import VideoRender from './VideoRender';
import VideoModal from './VideoModal';
import Wrapper from '../Wrapper';
import getClassModifiers from '../../utils/get-class-modifiers';
import { shouldShowProperty } from '../../helpers';
const Video = _ref => {
  let {
      url,
      modifier,
      autoplay,
      isCaptionDisplayed,
      caption,
      credits,
      areVideoCreditsDisplayed,
      provider,
      playInModal,
      imageId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    data: {
      getFile: imageData
    },
    loading
  } = useGetImages(imageId);
  if (loading) return '';
  if (!url) return null;
  const modifiers = `video--${provider.toLowerCase()} ${getClassModifiers('video', _objectSpread({
    modifier
  }, props))}`;
  const shouldDisplayCaption = shouldShowProperty({
    isDisplayed: isCaptionDisplayed,
    value: caption
  });
  const shouldDisplayCredits = shouldShowProperty({
    isDisplayed: areVideoCreditsDisplayed,
    value: credits
  });
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: "video",
    modifiers: modifiers
  }, playInModal ? /*#__PURE__*/React.createElement(VideoModal, _extends({
    url: url,
    modifier: modifier,
    autoplay: autoplay,
    provider: provider,
    imageData: imageData
  }, props)) : /*#__PURE__*/React.createElement(VideoRender, _extends({
    url: url,
    modifier: modifier,
    autoplay: autoplay,
    provider: provider,
    imageData: imageData
  }, props)), (shouldDisplayCaption || shouldDisplayCredits) && /*#__PURE__*/React.createElement("div", {
    className: "video__details",
    "data-testid": "video-details"
  }, shouldDisplayCaption && /*#__PURE__*/React.createElement("div", {
    className: "caption"
  }, caption), shouldDisplayCredits && /*#__PURE__*/React.createElement("div", {
    className: "credits"
  }, credits)));
};
Video.propTypes = {
  url: PropTypes.string,
  modifier: PropTypes.string,
  caption: PropTypes.string,
  credits: PropTypes.string,
  autoplay: PropTypes.bool,
  areVideoCreditsDisplayed: PropTypes.bool,
  isCaptionDisplayed: PropTypes.bool,
  provider: PropTypes.string,
  playInModal: PropTypes.bool,
  imageId: PropTypes.string
};
Video.defaultProps = {
  caption: '',
  credits: '',
  modifier: '',
  imageId: '',
  url: '',
  provider: 'youtube',
  autoplay: false,
  isCaptionDisplayed: false,
  areVideoCreditsDisplayed: false,
  playInModal: false
};
export default Video;
//# sourceMappingURL=Video.js.map